export default __webpack_public_path__ + "static/media/icon4.9d7609e8.png";